import { useEffect, useState, useRef } from "react";
import { FaPrint } from "react-icons/fa";
import emailjs from "emailjs-com";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const SuccessPage = () => {
  const hasProcessed = useRef(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [orderInfo, setOrderInfo] = useState({});
  const cardRef = useRef();

  useEffect(() => {
    if (hasProcessed.current) return;

    
    const queryParams = new URLSearchParams(window.location.search);
    const imageSrc = decodeURIComponent(queryParams.get("imageSrc") || "");
    const src = decodeURIComponent(queryParams.get("image") || "");
    const email = decodeURIComponent(queryParams.get("email") || "");
    const orderNumber = queryParams.get("order_number");
    const confirmationNumber = queryParams.get("confirmation_number");
    const size = queryParams.get("size");
    const id = queryParams.get("id");
    const ax = queryParams.get("ax");
    const price = queryParams.get("price");
    const available = (queryParams.get("available") || "").split(",");

    setOrderInfo({
      imageSrc,
      orderNumber,
      confirmationNumber,
      size,
      ax,
      price,
      available,
      email,
    });

    // Always download the PNG file
    const link = document.createElement("a");
    link.href = src;
    link.download = src.split("/").pop();
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Always open modal
    setModalOpen(true);

    // Send email with order info
    sendEmail({
      imageSrc,
      orderNumber,
      confirmationNumber,
      size,
      ax,
      src,
      available,
      price,
      email,
      id,
    });

    hasProcessed.current = true;
  }, []);

  const sendEmail = (data) => {
    const itemsTable = `
      <table border="1" cellpadding="6" cellspacing="0" style="border-collapse: collapse; font-size: 14px;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            <th>Order #</th>
            <th>Confirmation #</th>
          
         
            <th>Path</th>
   
            <th>Image</th>
         
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${data.orderNumber}</td>
            <td>${data.confirmationNumber}</td>
          
            <td>${data.imageSrc}</td>
        
            <td><a href="${
              data.src
            }" target="_blank" rel="noopener noreferrer">View Image</a></td>
        
            <td>${data.email}</td>
          </tr>
        </tbody>
      </table>
    `;

    emailjs
      .send(
        "service_ra0tzqd",
        "template_dcrf6kr",
        {
          from_name: "Wear & Wonder Boutique",
          to_name: "Payam",
          html_body: itemsTable,
        },
        "K6B2QrefJnYCDCTa1"
      )
      .then(() => console.log("✅ Email sent successfully"))
      .catch((err) => console.error("❌ Error sending email:", err));
  };

  const handlePrint = async () => {
    const element = cardRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("confirmation.pdf");
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <div
        ref={cardRef}
        style={{
          maxWidth: "600px",
          margin: "2rem auto",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
          position: "relative",
          fontFamily: "Nunito Sans, sans-serif",
          color: "#404F5E",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <img
            src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.gif"
            alt="success"
            style={{ maxWidth: 50, marginBottom: 12 }}
          />
          <h1 style={{ color: "#88B04B", fontWeight: 900, fontSize: 40 }}>
            Payment Successful
          </h1>
          <p style={{ fontSize: 18, margin: "1rem 0" }}>
            We received your purchase request; <br />
            we'll be in touch shortly!
          </p>
        </div>

        <table
          style={{
            width: "100%",
            marginTop: "1.5rem",
            borderCollapse: "collapse",
            fontSize: 16,
          }}
        >
          <tbody>
            <tr>
              <td style={{ padding: "8px 0", fontWeight: "bold" }}>
                Order Number:
              </td>
              <td style={{ padding: "8px 0" }}>{orderInfo.orderNumber}</td>
            </tr>
            <tr>
              <td style={{ padding: "8px 0", fontWeight: "bold" }}>
                Confirmation Number:
              </td>
              <td style={{ padding: "8px 0" }}>
                {orderInfo.confirmationNumber}
              </td>
            </tr>
          </tbody>
        </table>

        <button
          onClick={handlePrint}
          style={{
            position: "absolute",
            bottom: "1rem",
            right: "1rem",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#888",
            fontSize: 18,
          }}
          title="Print or Save as PDF"
        >
          <FaPrint />
        </button>
      </div>

      {modalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h2>Thank you</h2>
            <p>We will send the download link to you as soon as possible.</p>
            <button
              onClick={() => setModalOpen(false)}
              style={{
                backgroundColor: "#88B04B",
                color: "#fff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessPage;
